export default {
  slug: "ktor",
  code: "KTR",
  label: "Ktor",
  isKED: true,
  hasSubtitle: true,
  hasSubtitle2: true,
  logoFamily: "jb",
};
